import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInputFeildTransport from '../../../component/Produzioni/TableInputFeildTransport';
import TableInputAffinamento from '../../../component/Produzioni/TableInputAffinamento';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { useDispatch, useSelector } from 'react-redux';
import { resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';

const Affinamentoeinvecchiamento = ({option, activeStep, setActiveStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const submitForm = useSelector((state) => state.produzioniForm.submitForm);

    const [tableData, setTableData] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_affinamento: null, cantina_id: "", tipo_di_contenitore: "", temperatura_affinamento: "", umidita_cantina: "" },
    ]);

    const [treatment, setTreatment] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID,  pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
    ]);


    const data = {
        id: 1,
        title: "Affinamento e invecchiamento",
        description:
            "Organizza la raccolta assicurando che l'uva venga selezionata con cura per preservare la qualità del vino.",
        buttonText: "Completa fase",
    };
    const dummyData = {

        temperatureCompliance: tableData.length,
        totalCollected: "15.433 lt",
        discardedGrapes: (tableData.reduce((acc, item) => acc + Number(item.temperatura_affinamento), 0)/tableData.length).toFixed(2) + "°",
        cantina: (tableData.reduce((acc, item) => acc + Number(item.umidita_cantina), 0)/tableData.length).toFixed(2),
        tasks: [
            "Trasferimento in botti o serbatoi",
            "Monitoraggio della qualità del vino",
            "Controllo parametri ambientali",
        ],
    };

    const infoFields = [
        { label: "Numero contenitori", key: dummyData.temperatureCompliance },
        { label: "Totale Vino in affinamento ", key: dummyData.totalCollected },
        { label: "Temperatura affinameto", key: dummyData.discardedGrapes, showIcon: true },
        { label: "Umidità cantina", key: dummyData.cantina, showIcon: true },
    ];

const fetchDataForUpdate = async () => {
    try {
      const payload = {
        company_id: localStorage.getItem('company_id'),
        step: activeStep,
        prod_id: singleProduzioneID,
      };

      const response = await produzioniFormAPI.getSingleStepFormData(payload);
      console.log(response, "response racolta")
      if (response?.data.data.affinamento?.length) {
        const existingTable = response.data.data.affinamento;
        setTableData(existingTable);
      }
      if (response?.data.data.production_step_treatment?.length) {
        const existingTreatment = response.data.data.production_step_treatment;
        setTreatment(existingTreatment);
      }
    } catch (error) {
      console.error("Error fetching single step form data:", error);
    }
  };
  
  useEffect(() => {
      fetchDataForUpdate();
  }, []);

    const onSubmit = async (tableData, treatment) => {
        const data = {
            step: activeStep,
            forms: {
                affinamento: tableData,
                production_step_treatment: treatment
            }
        }
        console.log("Submitted data:", data);
        try {
              await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
            
            setActiveStep((prev) => prev + 1);
          } catch (error) {
            fetchDataForUpdate();
            console.error('Error submitting form data:', error);
          }
    };

    useEffect(() => {
        if (submitForm) {
            onSubmit(tableData, treatment);
            dispatch(resetFormSubmit());
        }
    }, [submitForm, dispatch]);

    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <DashboardCard dummyData={dummyData} infoFields={infoFields} />
            <TableInputAffinamento 
            option={option} 
            rows={tableData}
                setRows={setTableData}
                activeStep={activeStep}
                />
            <TrattamentiFrom 
            option={option} 
            rows={treatment}
                setRows={setTreatment}
                activeStep={activeStep}
                />
        </>
    )
}

export default Affinamentoeinvecchiamento